<template>
  <div class="aboutus_wrapper">
    <v-header :status="true" />
    <div>
      <img style="width:100%" src="../assets/img2/about_banner_1.png" />
    </div>
    <div class="company-box" id="corporation">
      <img src="../assets/img2/about_mrdata.png" />
      <img src="../assets/img2/about_introduce.png" />
    </div>
    <div style="text-align:center">
      <img class="about-company-img" src="../assets/img2/about_company.png" />
    </div>
    <div class="business-box">
      <img style="width:100%" src="../assets/img2/about_business.png" />
      <img src="../assets/img2/about_friend.png" />
      <img style="width:100%" src="../assets/img2/about_honor.jpg" />
      <img style="width:100%" src="../assets/img2/about_trademark.png" />
    </div>
  </div>
</template>
<script>
import VHeader from "../components/Header.vue";
export default {
  name: "AboutUs",
  components: { VHeader },
  mounted() {
    const that = this;
    if (document.getElementById(that.$route.query.hashId)) {
      document.getElementById(that.$route.query.hashId).scrollIntoView({block:'center'});
      that.$forceUpdate();
    }
    setTimeout(() => {
      if (document.getElementById(that.$route.query.hashId)) {
        document.getElementById(that.$route.query.hashId).scrollIntoView({block:'center'});
        that.$forceUpdate();
      }
    }, 10);
  },
};
</script>
<style lang="less" scoped>
.instruction {
  position: relative;
}
.margin-top40 {
  margin-top: 40px;
}
.company-box {
  display: flex;
  margin-top: 114px;
  margin-bottom: 30px;
  > img:first-child {
    width: 1132px;
    margin-left: 172px;
  }
  > img:last-child {
    width: 497px;
    height: 839px;
    margin-left: -264px;
    margin-top: 40px;
    
  }
}
.business-box {
  margin-top: 136px;
  > img:nth-child(2) {
    width: 1196px;
    margin: 0 auto;
    display: block;
    margin-bottom: 168px;
  }
}
.about-company-img{
  width: 1217px;
  height: 742px;
}
</style>
